export const dateOptions = [
  {
    title: 'anyTime',
    days: '',
  },
  {
    title: 'olderThanAWeek',
    days: '7',
  },
  {
    title: 'olderThanAMonth',
    days: '31',
  },
  {
    title: 'olderThanSixMonths',
    days: '182',
  },
  {
    title: 'olderThanOneYear',
    days: '365',
  },
  {
    title: 'recent',
    days: '60',
  },
]

export function getDaysByTitle(title) {
  const option = dateOptions.find(option => option.title === title);
  return option ? option.days : null;
}
